import { gql } from "@apollo/client";

/**
 * Installations of one serial number, for AssetInstallationsWidget.
 *
 * iotConnection must NEVER be selected here. This list contains the currently
 * open assetLocation, so its iotConnection normalizes straight onto
 * AssetLocation:<id> and overwrites what the dashboard's own queries wrote —
 * and the backend silently nulls the WHOLE iotConnection when a device's hub
 * lookup fails (see assetIoTConnectionWidget.ts). A null arriving here blanks
 * the hero lead and drops the IoT entries from the asset actions menu.
 * The widget never rendered the field anyway.
 */
export const AssetInstallationsList = gql`
    query AssetInstallationsList($filter: SearchAssetFilter) {
        searchAssets(filter: $filter) {
            total
            searchAssetResults {
                id
                assetLocation {
                    id
                    title
                    installationDate
                    installedBaseNode {
                        id
                        title
                    }
                    owner {
                        id
                        name
                    }
                }
            }
        }
    }
`;
